import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-289d4201"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }

import { storeToRefs } from 'pinia';
import { useCommonStore } from '@/store/common';
import AppHeader from '@/components/common/AppHeader/AppHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateApp',
  setup(__props) {

const { isMobile } = storeToRefs(useCommonStore());
const { servicesList } = storeToRefs(useCommonStore());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-template d-flex flex-column", {'app-template--mobile': _unref(isMobile) }])
  }, [
    (_unref(servicesList).length)
      ? (_openBlock(), _createBlock(AppHeader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})